/**
 * General functions that are used in the app
 */

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { logOut } from "../redux/authentication/actionCreator";
import { logout } from "../hooks/authFunctions";

/**
 * Get the token from the redux store
 * @returns {string} The token
 */
export const GetToken = () => {
  const token = useSelector((state) => state.auth);
  return token;
};

/**
 * Sign out user
 * @returns {function} The sign out function.
 */
export const useSignOutGeneral = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const signOut = () => {
    //logout aws session
    logout();
    //logout system session
    dispatch(logOut());
    //redirect to login page
    history.push("/");
  };

  return signOut;
};
